/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreeActionDTO,
  PersonAgreeActionDTOOptional,
  PersonAgreeActionDTOMetaI,
  PersonAgreeActionDTOTrackedI,
} from "./person-agree-action-dto";
import {
  PersonAgreeActionDTOTracked,
  PersonAgreeActionDTOMeta,
} from "./person-agree-action-dto";

/**
 *
 * @export
 * @interface PersonAgreeDTO
 */
export interface PersonAgreeDTOOptional {
  /**
   *
   * @type {Array<PersonAgreeActionDTO>}
   * @memberof PersonAgreeDTO
   */
  agreementActions?: PersonAgreeActionDTOOptional[];
}

export interface PersonAgreeDTO extends PersonAgreeDTOOptional {
  /**
   *
   * @type {Array<PersonAgreeActionDTO>}
   * @memberof PersonAgreeDTO
   */
  agreementActions?: PersonAgreeActionDTO[];
}

export interface PersonAgreeDTOTrackedI {
  /**
   *
   * @type {Array<PersonAgreeActionDTO>}
   * @memberof PersonAgreeDTO
   */
  agreementActions?: PersonAgreeActionDTOTrackedI[];
  agreementActionsIsSet: boolean;
}

transformDatesMap.set("PersonAgreeDTO", function (model: PersonAgreeDTO) {
  const transformDatesagreementActions = transformDatesMap.get(
    "PersonAgreeActionDTO",
  );
  if (transformDatesagreementActions) {
    model.agreementActions?.forEach((sub) => {
      transformDatesagreementActions(sub);
    });
  }
});

export type PersonAgreeDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  agreementActions: PropertyMeta<PersonAgreeActionDTOMetaI>;
}>;

export var PersonAgreeDTOMeta: PersonAgreeDTOMetaI = {} as PersonAgreeDTOMetaI;
PersonAgreeDTOMeta = typeMeta("PersonAgreeDTO", {
  agreementActions: propertyMeta(
    "agreementActions",
    true,
    false,
    false,
    PersonAgreeActionDTOMeta,
  ),
});

const metaI = PersonAgreeDTOMeta;

registerMeta(() => {});

export class PersonAgreeDTOTracked implements PersonAgreeDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  agreementActions__I?: PersonAgreeActionDTOTracked[] = undefined;
  agreementActionsIsSet: boolean = false;
  set agreementActions(v: undefined | PersonAgreeActionDTOTracked[]) {
    if (v !== undefined) {
      this.agreementActions__I = v;
      this.agreementActionsIsSet = true;
    } else {
      this.agreementActions__I = v || undefined;
      this.agreementActionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementActions() {
    return this.agreementActions__I;
  }
  constructor(config?: PersonAgreeDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.agreementActions?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonAgreeDTOOptional,
    options?: AssignOptions,
  ): PersonAgreeDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.agreementActions &&
      this.agreementActionsApplyFilter(optionsRequired.filter)
    ) {
      this.agreementActions = config.agreementActions?.map(
        (a) => new PersonAgreeActionDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.agreementActionsIsSet = false;
      else this.agreementActionsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreeDTOTrackedI {
    const cloned = {} as PersonAgreeDTOTrackedI;
    if (
      this.agreementActionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.agreementActionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementActionsIsSet = true;
      cloned.agreementActions = this.agreementActions
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.agreementActionsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreeDTOTrackedI {
    if (!this.agreementActionsApplyFilter(filter))
      this.agreementActionsIsSet = false;

    this.agreementActions?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  agreementActionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreeDTOMeta.agreementActions,
      PersonAgreeDTOMeta,
      this.agreementActions,
      this,
    );
  }
  agreementActionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementActionsIsSet && this.agreementActionsApplyFilter(filter))
      return true;

    return this.agreementActions?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.agreementActionsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
